export default "__VITE_ASSET__DuQtbujg__"